import React, { FC, useContext, useEffect, useState } from "react";
/*import { useOktaAuth } from "@okta/okta-react";*/
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import LayoutHeader from "./components/LandingHeader";
import SingleColLayout from "../../common/components/layouts/SingleCol";
import Button from "@mui/material/Button";
import CreateProjectDialog from "./components/CreateProjectDialog";
import ProjectList from "./../../components/project/components/list/ProjectList";
import ConfirmationModal from "../../common/components/dialogs/ConfirmationModal";
/*import OktaAuth, { AccessToken, AuthState } from "@okta/okta-auth-js";*/
import { Typography, Box } from "@mui/material";
import { LanguageContext } from "common/contexts/LanguageContext";
import { useAuthContext } from "common/contexts/AuthContext";
import { useAuth0 } from "@auth0/auth0-react";

const Landing: FC = () => {
  const [createProjectModalOpen, setCreateProjectModalOpen] =
    useState<boolean>(false);
  const [confirmationModalOpen, setConfirmationModalOpen] =
    useState<boolean>(false);
    const [accessToken, setAccessToken] = useState<string | null>(null);
 /* const { authState, oktaAuth } = useOktaAuth();*/
  const { getString } = useContext(LanguageContext);
  const { isAuthenticatedUser } = useAuthContext();
  const { loginWithRedirect } = useAuth0(); // Use Auth0's isAuthenticated property

  //const handleUserLoginAsync = async (
  //  authState: AuthState | null,
  //  oktaAuth: OktaAuth | null
  //) => {
  //  if (authState?.isAuthenticated) {
  //    if (oktaAuth !== null) {
  //      var accessToken = await oktaAuth.tokenManager.get("accessToken");
  //      if (accessToken) {
  //        console.log(accessToken);
  //      }

  //      const user = await oktaAuth.token.getUserInfo();
  //      console.log(
  //        `${user.family_name?.charAt(0)}  ${user.given_name?.charAt(0)}`
  //      );
  //    }

  //    const claims = authState.idToken?.claims;
  //    if (claims !== undefined) {
  //      console.log(claims);
  //    }
  //  }
  //};

  //useEffect(() => {
  //  if (authState?.isAuthenticated) {
  //    // oktaAuth.tokenManager.get("accessToken").then((accessToken) => {
  //    //   if (accessToken) {
  //    //     setAccessToken(accessToken as AccessToken);
  //    //     console.log(accessToken);
  //    //   }
  //    // });

  //    (async () => {
  //      await handleUserLoginAsync(authState, oktaAuth);
  //    })();
  //  }
  //}, [authState, oktaAuth]);

  //useEffect(() => {
  //  (async () => {
  //    const accessToken = await getAccessToken();
  //    setAccessToken(accessToken);
  //  })();
  //}, [getAccessToken])

  const handleCreateProjectClick = () => {
    setCreateProjectModalOpen(true);
  };

    const handleLogin = async () => loginWithRedirect({
        authorizationParams: {
            'ext-returnPath': '/en-us/',
            'ext-returnuri': 'https://q.wirelessplanning.emerson.com',
            'ext-redirectURI': 'https://q.wirelessplanning.emerson.com/en-us'
        }
    });

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <SingleColLayout isLoading={false} fullWidth={false}>
        <LayoutHeader></LayoutHeader>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={handleCreateProjectClick}>
            {getString("btn_createproject")}
            <ChevronRightOutlinedIcon />
          </Button>
        </Box>
              {isAuthenticatedUser && (
          <div style={{ marginTop: "-40px" }}>
            <ProjectList />
          </div>
        )}
              {isAuthenticatedUser !== true && (
          <Box
            sx={{
              border: 1,
              borderColor: "lightgray",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              height: "400px",
              mt: "12px",
              p: 1,
            }}
          >
            <Typography variant="body1">
              {getString("wlcm_createactprefix")}
              <Button variant="text" onClick={handleLogin}>
                {getString("wlcm_createact")}
              </Button>
              {getString("wlcm_createactsuffix")}
            </Typography>
          </Box>
        )}
        <CreateProjectDialog
          isOpen={createProjectModalOpen}
          setOpen={setCreateProjectModalOpen}
        />
        <ConfirmationModal
          isOpen={confirmationModalOpen}
          handleClose={() => setConfirmationModalOpen(false)}
          title={getString('cmn_please_confirm')}
          maxWidth="md"
          handleConfirm={() => {
            console.log("Confirm button handler");
            setConfirmationModalOpen(false);
          }}
        >
         {/* {accessToken?.accessToken}*/}
        </ConfirmationModal>
      </SingleColLayout>
    </Box>
  );
};

export default Landing;
